module.exports = "../../app/cells/components/modals/account_limit_free_modal/campaign_modal.erb";